import { pipe, filter, UnaryFunction, Observable } from 'rxjs';

export const filterTruthy = <T>() => {
  return pipe(
    filter((data: T) => {
      return data != null;
    }),
  ) as UnaryFunction<Observable<T>, Observable<Exclude<T, null | undefined>>>;
};